import React from 'react'
import classNames from 'classnames'
import { getMenuLinks } from '../helpers/constant'
import { Link } from 'react-router-dom'
import MenuDotsIcon from '~images/menu-dots-icon.svg'

export const BurgerMenu: React.FC<any> = ({ link, onClick, phone }) => {
  const [isActiveMenu, setActiveMenu] = React.useState<boolean>(false)
  const links = getMenuLinks()

  const handleToggle = () => {
    setActiveMenu(!isActiveMenu)
    if (!isActiveMenu) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'visible'
    }
  }
  return (
    <>
      <div
        onClick={handleToggle}
        className={classNames('onlinepbx__burger__menu', {
          'onlinepbx__burger__menu__active': isActiveMenu
        })}>
        <div className='onlinepbx__burger__menu__dots'><MenuDotsIcon /></div>
        <div className='onlinepbx__burger__menu__text'>Меню</div>
      </div>
      {isActiveMenu && <div
        onClick={handleToggle}
        className='onlinepbx__burger__menu__open'>
        <div className='onlinepbx__burger__menu__open__links'>
          {links.map(link => <div
            key={link.route}
            className='onlinepbx__burger__menu__open__link__block'>
              <div className="onlinepbx__burger__menu__open__link__wrapper">
                {
                  link?.route?.includes('https://') ?
                      <a
                        className='onlinepbx__burger__menu__open__link'
                        href={link.route}
                        target='_self'
                        rel='noopener noreferrer'
                      >
                        {link.name}
                      </a> :
                      <Link
                          className='onlinepbx__burger__menu__open__link'
                          to={link.route}>
                        {link.name}
                      </Link>
                }
                {
                  link?.links?.length && (
                    link.links.map(sublink => (
                      <Link
                        className='onlinepbx__burger__menu__open__sublink'
                        to={sublink.route}>
                        {sublink.name}
                      </Link>
                    ))
                  )
                }
              </div>
          </div>
          )}
        </div>
        <div>
          <button
            onClick={onClick}
            className='onlinepbx__menu__button__fill'>
            Регистрация
          </button>
          <button
            onClick={() => window.open(`${link}/login`, '_blank')}
            className='onlinepbx__menu__button__border'>
            Вход
        </button>
          <a href={`tel:+${phone.value}`} className='onlinepbx__burger__menu__open__phone'>
            {phone.text}
        </a>
        </div>
      </div>}
    </>
  )
}

export default BurgerMenu
